import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { _ } from "src/services";
import { Modals, ModalsAction, ReportProblemAction, ReportProblemState } from "src/store";
import { Loading } from "../ui";
import { Modal } from "./modal";

export const ReportModal: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const { id }: any = useParams();
    const modals: Modals = useSelector((state: any) => state.ModalsState);
    const report: ReportProblemState = useSelector((state: any) => state.ReportState);

    //#endregion

    //#region states

    const [typeOptions] = useState([
        { title: _("brokenStream"), value: 1 },
        { title: _("inaccessibility"), value: 2 },
    ]);

    const [state, setState] = useState({
        issueItemId: typeOptions[0].value,
        body: "",
    });

    //#endregion

    //region methods

    const onClose = () => dispatch(ModalsAction.hideReport());

    const onSend = () => (state.body?.trim() && !report.loading && state.issueItemId) && dispatch(ReportProblemAction.submit(state, id));

    const onChangeType = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        setState((x) => ({ ...x, issueItemId: +value }));
    };

    const onChangeDescription = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        setState((x) => ({ ...x, body: value }));
    };

    //#endregion


    //#region effects

    useEffect(() => {

        if (!modals.report) {
            setState({
                issueItemId: typeOptions[0].value,
                body: "",
            });
        }

    }, [modals.report, typeOptions]);

    useEffect(() => {
        return () => {
            dispatch(ModalsAction.hideReport());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //#endregion

    //#region helpers

    const renderFooter = () => {

        const disabled = !state.body?.trim() || report.loading || !state.issueItemId;

        return (
            <>
                <div className="col-12 d-flex">
                    <button onClick={onSend} disabled={disabled} className={`btn-a mx-auto mb-2 mb-sm-4 btn-md ${disabled ? "btn-disabled" : "btn-primary"}`}>
                        {report.loading && <Loading width={30} height={30} />}
                        {!report.loading && _("send")}
                    </button>
                </div>
            </>
        );
    };


    const renderBody = () => {
        return (
            <div className="content form-group mb-0" >
                <div className="sub-title text-center">
                    {_("reportMessage")}
                </div>
                <label className="d-block title m-0">{_("type")}</label>
                <div className="row">
                    <div className="col-12 float-right mb-4">
                        <select className="text-right mb-3 w-100 dropdown" value={state.issueItemId} onChange={onChangeType}>
                            {typeOptions.map((x, i) => <option title={x.title} value={x.value} key={x.value}>{x.title}</option>)}
                        </select>
                    </div>
                </div>
                <label className="d-block title m-0">{_("reportDescription")}</label>
                <div className="row">
                    <div className="col-12 float-right mb-4">
                        <textarea
                            value={state.body} onChange={onChangeDescription}
                            rows={1}
                            className="w-100 modal-report-text-area text-rtl text-right"
                        />
                    </div>
                </div>
            </div>
        );
    };

    //#endregion

    return (
        <Modal title={_("reportTitle")} show={modals.report} onClose={onClose} renderFooter={renderFooter} lg className="modal-component--problem-report">
            {renderBody()}
        </Modal>
    );
};